import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

export function FAQCta() {
    return (
        <section className="bg-[#F8F9FA] py-20">
            <div className="max-w-2xl mx-auto px-6 text-center">
                <motion.div {...fadeUp}>
                    <h2 className="font-montserrat font-bold text-3xl text-navy-900 mb-4">Still have questions?</h2>
                    <p className="text-[#6B7280] mb-8 text-sm">Reach out directly or schedule a free call. We'll give you straight answers.</p>
                    <div className="flex flex-wrap justify-center gap-4">
                        <Link to="/contact" data-testid="faq-cta-contact" className="bg-navy-900 text-white px-8 py-3.5 rounded-sm text-sm font-bold hover:bg-navy-950 transition-colors">
                            Contact Us
                        </Link>
                        <a
                            href="https://calendly.com/adam-whiteglovehiring/wgh-va-consultation"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="faq-cta-calendly"
                            className="border border-navy-900 text-navy-900 px-8 py-3.5 rounded-sm text-sm font-bold hover:bg-navy-900 hover:text-white transition-colors"
                        >
                            Schedule a Call
                        </a>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
